import { hotjar } from './hotjar';
import queryString from 'query-string';

export const init = function () {
  initHotjar();
};

function initHotjar() {
  let hjid = +(queryString.parse(window.location.search).hjid || 0);
  !!hjid && hotjar(hjid);
}
